<div [innerHTML]="svgContent" [ngClass]="colorClass" [style.width.px]="size" [style.height.px]="size" [style.color]="color"></div>
